__turbopack_context__.v({
  "actionCell": "fieldRowStyles-module-scss-module__mjkfda__actionCell",
  "box": "fieldRowStyles-module-scss-module__mjkfda__box",
  "currency": "fieldRowStyles-module-scss-module__mjkfda__currency",
  "cusip": "fieldRowStyles-module-scss-module__mjkfda__cusip",
  "datePurchased": "fieldRowStyles-module-scss-module__mjkfda__datePurchased",
  "deal": "fieldRowStyles-module-scss-module__mjkfda__deal",
  "dealSelect": "fieldRowStyles-module-scss-module__mjkfda__dealSelect",
  "inputField": "fieldRowStyles-module-scss-module__mjkfda__inputField",
  "row": "fieldRowStyles-module-scss-module__mjkfda__row",
});
